import { CreateService, CRUDServiceInterface } from '@/services/service';
import { LessonTestResultAnswerEntity } from '@/entities/lesson-test-result-answer.entity';

export default class LessonTestResultAnswerService
  extends CreateService<LessonTestResultAnswerEntity>(
    'lesson-test-result-answer',
  )
  implements CRUDServiceInterface<LessonTestResultAnswerEntity>
{
  async getMany(): Promise<LessonTestResultAnswerEntity[]> {
    const [items] = await this.apiBuilder.getMany();
    return items;
  }

  async getAnswersByResultId(
    id: string | number,
  ): Promise<LessonTestResultAnswerEntity[]> {
    this.apiBuilder.reset()
    const [items] = await this.apiBuilder
      .filter('resultId', '$eq', String(id))
      .getMany();
    return items;
  }
}
